// extracted by mini-css-extract-plugin
export var paginationContainer = "_6w-0";